<template>
  <v-container class="fill-height d-flex justify-center align-center" fluid>
    <v-card class="justify-center ma-12">
      <v-card-title>
        <p>Verify Email</p>
      </v-card-title>
      <v-card-subtitle class="py-0">
        <p>
          Please click the button below to verify your email.
        </p>
      </v-card-subtitle>
      <v-card-text>
        <VerifyEmailBtn />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  import VerifyEmailBtn from "./VerifyEmailBtn";

  export default {
    name: "VerifyEmailPage",
    components: { VerifyEmailBtn },
    created() {
      //FB sign out
      if (!this.$_.isEmpty(this.$sdkInstances.fbSDKInstance)) {
        this.$sdkInstances.fbSDKInstance.getLoginStatus((res) => {
          if (res.status === "connected") {
            this.$sdkInstances.fbSDKInstance.logout();
          }
        });
      }

      //Google sign out
      if (!this.$_.isEmpty(this.$sdkInstances.googleSDKInstance)) {
        if (this.$sdkInstances.googleSDKInstance.isSignedIn.get()) {
          this.$sdkInstances.googleSDKInstance.signOut();
        }
      }

      //Remove token from local storage and redirect to home page
      delete localStorage.token;
      delete localStorage.role;
      this.$sessionUser._clearUserInfo();
      this.$store.commit("logout");
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/VerifyEmail/VerifyEmailPage.vue